import { render, staticRenderFns } from "./technicalSpecifications.vue?vue&type=template&id=4f80451a&scoped=true&"
import script from "./technicalSpecifications.vue?vue&type=script&lang=js&"
export * from "./technicalSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./technicalSpecifications.vue?vue&type=style&index=0&id=4f80451a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80451a",
  null
  
)

export default component.exports